export default import.meta.ROLLDOWN_FILE_URL_07gvO1IvTzTCTyYqp_a5mw